// AI（Codex）

const agreementV2Index = resolve => require(['@/views/agreementV2/index.vue'], resolve)

export default [{
	path: '/agreement-v2',
	alias: ['/agreement-v2.htm'],
	component: agreementV2Index
}]
